import React from "react";
import arrow from "../../assets/images/arrow_back.svg";
import Header from "../../assets/images/Header.svg";
import LicenseIcon from "../../assets/icons/Vector.svg";
import CustomINput from "../../components/common/InputField/InputField";
import CustomDatepicker from "../../components/common/datePicker/DatePicker";
import CustomDropDown from "../../components/common/dropdown/Dropdown";
import Icon from "../../assets/icons/info.svg";
import IconArrow from "../../assets/icons/Vector (1).svg";
import arrowleft from "../../assets/icons/arrow-left.svg";
import english from "../../assets/icons/english-input.svg";
import user from "../../assets/icons/user.svg";
import "./PhysicianForm.css";

import Dropdown from "../../components/common/dropdown/Dropdown";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const dummyOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

const identityType = [
  { label: "National Number", value: "National Number" },
  { label: "Passport", value: "Passport" },
  { label: "Permanent Resident", value: "Permanent Resident" },
  { label: "Border Number", value: "Border Number" },
];

const PersonalInfo = ({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  handleClick,
  selectedTab,
  setFieldTouched,
  setTouched,
  validateForm,
  setFieldValue,
}) => {
  const nationalities = [
    { label: "Afghan", value: "Afghan" },
    { label: "Albanian", value: "Albanian" },
    { label: "Algerian", value: "Algerian" },
    { label: "American", value: "American" },
    { label: "Argentinian", value: "Argentinian" },
    { label: "Australian", value: "Australian" },
    { label: "Austrian", value: "Austrian" },
    { label: "Bangladeshi", value: "Bangladeshi" },
    { label: "Belgian", value: "Belgian" },
    { label: "Brazilian", value: "Brazilian" },
    { label: "British", value: "British" },
    { label: "Bulgarian", value: "Bulgarian" },
    { label: "Canadian", value: "Canadian" },
    { label: "Chilean", value: "Chilean" },
    { label: "Chinese", value: "Chinese" },
    { label: "Colombian", value: "Colombian" },
    { label: "Czech", value: "Czech" },
    { label: "Danish", value: "Danish" },
    { label: "Dutch", value: "Dutch" },
    { label: "Egyptian", value: "Egyptian" },
    { label: "Filipino", value: "Filipino" },
    { label: "Finnish", value: "Finnish" },
    { label: "French", value: "French" },
    { label: "German", value: "German" },
    { label: "Greek", value: "Greek" },
    { label: "Indian", value: "Indian" },
    { label: "Indonesian", value: "Indonesian" },
    { label: "Iranian", value: "Iranian" },
    { label: "Iraqi", value: "Iraqi" },
    { label: "Irish", value: "Irish" },
    { label: "Israeli", value: "Israeli" },
    { label: "Italian", value: "Italian" },
    { label: "Japanese", value: "Japanese" },
    { label: "Jordanian", value: "Jordanian" },
    { label: "Kenyan", value: "Kenyan" },
    { label: "Korean", value: "Korean" },
    { label: "Kuwaiti", value: "Kuwaiti" },
    { label: "Lebanese", value: "Lebanese" },
    { label: "Libyan", value: "Libyan" },
    { label: "Malaysian", value: "Malaysian" },
    { label: "Mexican", value: "Mexican" },
    { label: "Moroccan", value: "Moroccan" },
    { label: "Nepalese", value: "Nepalese" },
    { label: "Nigerian", value: "Nigerian" },
    { label: "Norwegian", value: "Norwegian" },
    { label: "Pakistani", value: "Pakistani" },
    { label: "Palestinian", value: "Palestinian" },
    { label: "Polish", value: "Polish" },
    { label: "Portuguese", value: "Portuguese" },
    { label: "Romanian", value: "Romanian" },
    { label: "Russian", value: "Russian" },
    { label: "Saudi", value: "Saudi" },
    { label: "Scottish", value: "Scottish" },
    { label: "Singaporean", value: "Singaporean" },
    { label: "South African", value: "South African" },
    { label: "Spanish", value: "Spanish" },
    { label: "Sri Lankan", value: "Sri Lankan" },
    { label: "Sudanese", value: "Sudanese" },
    { label: "Swedish", value: "Swedish" },
    { label: "Swiss", value: "Swiss" },
    { label: "Syrian", value: "Syrian" },
    { label: "Thai", value: "Thai" },
    { label: "Tunisian", value: "Tunisian" },
    { label: "Turkish", value: "Turkish" },
    { label: "Ukrainian", value: "Ukrainian" },
    { label: "Venezuelan", value: "Venezuelan" },
    { label: "Vietnamese", value: "Vietnamese" },
    { label: "Welsh", value: "Welsh" },
    { label: "Yemeni", value: "Yemeni" },
  ];

  const minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 20);

  return (
    <div
      className=" text-medium text-gray-500   rounded-lg w-full"
      id="profile"
      role="tabpanel"
      aria-labelledby="profile-tab"
    >
      <div className="flex items-center space-x-1 mb-4">
        <div className="pl-4">
          <img src={english} alt="License Icon" className="w-6 h-6 " />
        </div>
        <h3 className="label-medium pt-2">English Names</h3>
      </div>
      <div className="border-t border-l">
        <div className=" pt-1 ml-4 ">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <div>
              <CustomINput
                label="First English Name"
                className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[12px]"
                width=" w-full"
                height="h-[40px]"
                labelClass={`label-small`}
                isRequired={true}
                isRequiredClass="text-[#2D9F75]"
                name="firstName"
                value={values.firstName}
                onChange={handleChange}
                onBlur={handleBlur}
              />

              {errors.firstName && touched.firstName && (
                <div className="text-red-500 text-[12px]">
                  {errors.firstName}
                </div>
              )}
            </div>
            <div>
              <CustomINput
                label="Middle English Name"
                className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[12px]"
                width="w-full"
                height="h-[40px]"
                labelClass={`label-small`}
                isRequiredClass="text-[#2D9F75]"
                name="middleName"
                value={values.middleName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.middleName && touched.middleName && (
                <div className="text-red-500 text-[12px]">
                  {errors.middleName}
                </div>
              )}
            </div>

            <div>
              <CustomINput
                label="Last English Name"
                className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[12px]"
                isRequired={true}
                width="w-full"
                height="h-[40px]"
                labelClass={`label-small`}
                isRequiredClass="text-[#2D9F75]"
                name="lastName"
                value={values.lastName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.lastName && touched.lastName && (
                <div className="text-red-500 text-[12px]">
                  {errors.lastName}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="pt-6 ml-4">
          <div className="flex items-center space-x-1 mb-4">
            <div className="">
              <img src={user} alt="License Icon" className="w-6 h-6 " />
            </div>
            <h3 className=" label-medium pt-2 ">Other Personal Details</h3>
          </div>
          <hr />
          <div className="pt-1 mt-4">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 col-span-1 pb-4">
              <div>
                <CustomDropDown
                  label="Nationality"
                  className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none rounded-[11px]"
                  options={nationalities}
                  height="h-[40px]"
                  labelClass={`label-small`}
                  isRequired={true}
                  isRequiredClass="text-[#2D9F75]"
                  name="nationality"
                  value={values.nationality}
                  zIndex={"99999"}
                  search={true}
                  onChange={(e) => {
                    handleChange(e);
                    setFieldValue("nationality", e);

                    setFieldValue("identityType", "");
                  }}
                />
                {errors.nationality && touched.nationality && (
                  <div className="text-red-500 text-[12px]">
                    {errors.nationality}
                  </div>
                )}
              </div>
              <div>
                <CustomDropDown
                  className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[11px]"
                  options={identityType}
                  label="Identity Type"
                  height="h-[40px]"
                  type="number"
                  labelClass={`label-small`}
                  isRequired={true}
                  isRequiredClass="text-[#2D9F75]"
                  name="identityType"
                  value={values.identityType}
                  zIndex={"99999"}
                  onChange={(e) => {
                    handleChange(e);
                    setFieldValue("identityType", e);
                  }}
                  onBlur={handleBlur}
                />
                {
                  <div className="text-red-500 text-[12px]">
                    {errors.identityType}
                  </div>
                }
              </div>
              <div>
                <CustomINput
                  disabled={!values.identityType}
                  className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[11px]"
                  label="Identity Number"
                  height="h-[40px]"
                  type="text"
                  labelClass={`label-small`}
                  isRequired={true}
                  isRequiredClass="text-[#2D9F75]"
                  name="identityNumber"
                  value={values.identityNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.identityNumber && touched.identityNumber && (
                  <div className="text-red-500 text-[12px]">
                    {errors.identityNumber}
                  </div>
                )}
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
              <div>
                <CustomDatepicker
                  maxDate={minDate}
                  label="Date of Birth"
                  className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[11px]"
                  height="h-[40px]"
                  labelClass={`label-small`}
                  isRequired={true}
                  isRequiredClass="text-[#2D9F75]"
                  name="dateOfBirth"
                  value={values.dateOfBirth}
                  onChange={(e) => {
                    handleChange(e);
                    setFieldValue("dateOfBirth", e);
                  }}
                  onBlur={handleBlur}
                />
                {errors.dateOfBirth && touched.dateOfBirth && (
                  <div className="text-red-500 text-[12px]">
                    {errors.dateOfBirth}
                  </div>
                )}
              </div>
              <div>
                <CustomINput
                  className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[11px]"
                  label="Place of birth"
                  height="h-[40px]"
                  labelClass={`label-small`}
                  isRequired={true}
                  isRequiredClass="text-[#2D9F75]"
                  name="placeOfBirth"
                  value={values.placeOfBirth}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.placeOfBirth && touched.placeOfBirth && (
                  <div className="text-red-500 text-[12px]">
                    {errors.placeOfBirth}
                  </div>
                )}
              </div>
              <div>
                <Dropdown
                  label="Gender"
                  className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none rounded-[11px]"
                  isRequired={true}
                  options={dummyOptions}
                  height="h-[40px]"
                  labelClass={`label-small`}
                  isRequiredClass="text-[#2D9F75]"
                  name="gender"
                  value={values.gender}
                  zIndex={"99999"}
                  onChange={(e) => {
                    handleChange(e);
                    setFieldValue("gender", e);
                  }}
                  onBlur={handleBlur}
                />
                {errors.gender && touched.gender && (
                  <div className="text-red-500 text-[12px]">
                    {errors.gender}
                  </div>
                )}
              </div>

              <div>
                <label
                  htmlFor="phoneNumber"
                  className="block text-gray-700 text-sm font-bold mb-2"
                >
                  Phone Number
                </label>

                <PhoneInput
                  country={"us"}
                  value={values.phoneNumber}
                  onChange={(phone) => setFieldValue("phoneNumber", phone)}
                  inputStyle={{
                    fontSize: "14px",
                    height: "39px",
                    borderRadius: "12px",
                    width: "100%",
                    paddingLeft: "56px",
                  }}
                  buttonStyle={{
                    width: "55px",
                    paddingLeft: "10px",
                    borderRadius: "12px",
                    border: "1px solid #ccc",
                  }}
                />

                {errors.phoneNumber && touched.phoneNumber && (
                  <div className="text-red-500 text-[12px]">
                    {errors.phoneNumber}
                  </div>
                )}
              </div>
              <div>
                <CustomINput
                  label="Email"
                  className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[11px]"
                  isRequired={true}
                  height="h-[40px]"
                  labelClass={`label-small`}
                  isRequiredClass="text-[#2D9F75]"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.email && touched.email && (
                  <div className="text-red-500 text-[12px]">{errors.email}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-end items-center pt-20">
        <div className="flex items-center justify-between w-[300px]">
          <button
            type="button"
            onClick={() => handleClick(1)}
            class="w-[128px] h-[40px] text-[#007A63] flex justify-center items-center  border border-[#007A63]  focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm  text-center  [#007A63] [#007A63] :text-white"
          >
            <img src={arrowleft} alt="logo" style={{ paddingRight: "12px" }} />
            Previous
          </button>
          <button
            onClick={() =>
              handleClick(3, validateForm, setTouched, setFieldTouched)
            }
            className="text-white bg-[#007A63] flex justify-center items-center  focus:ring-4 focus:outline-none w-[128px] h-[40px] font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
          >
            Next
            <img src={IconArrow} alt="logo" style={{ paddingLeft: "12px" }} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
